<div class="wm-login-container">
  <div class="wm-login-container-image"></div>
  <div>
    <router-outlet></router-outlet>
  </div>
  <div class="release-info">
    <div class="release-date">2026-09-01</div>
    <a href="https://docs.webmate.io/releases/latest" target="_blank">Release 2026.3.1</a>
  </div>
</div>